import React, {Dispatch, SetStateAction, useState} from 'react';
import StyledPaper from './shared/StyledPaper';
import npsService from '../services/npsService';
import {useParams} from 'react-router';
import {Button, Grid, TextField, Typography, useTheme} from '@material-ui/core';
import StyledSnackbar from './shared/StyledSnackbar';
import RateItem from './RateItem';
import styled from 'styled-components';

const ButtonWrapper = styled(Grid)`
  display: flex;
  justify-content: center;
`;

const CommentBlock = styled(Grid)`
  margin: 20px auto 10px auto;
`;

const Border = styled.div`
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const BorderItem = styled.span.attrs(
    // (props: { color: 'red' | 'green' | 'blue', size: number },
    (props: any,
    ) => ({
      color: props.color,
      variant: props.variant,
      size: props.size,
      mr: props.mr,
      pr: props.pr,
    }))`
  display: flex;
  height: 4px;
  flex-grow: ${props => props.size};
  background-color: ${props => props.theme.palette[props.variant].main};
  margin-right: ${props => props.mr};
  padding-right: ${props => props.pr};
  border-radius: 4px;
`;

/**
 * Desktop version of Rate component
 * @param question
 * @param rated - callback
 */
const RateDesktop = ({question, rated}:
                         {
                           question: string,
                           rated: any
                         }) => {

  const theme = useTheme();
  const {hash} = useParams();
  const [rate, setRate]: [number | null, Dispatch<SetStateAction<any>>] = useState(
      0);
  const [showError, setError]: [boolean, Dispatch<SetStateAction<any>>] = useState(
      false);
  const [comment, setComment]: [string | undefined, Dispatch<SetStateAction<any>>] = useState();

  const sendRate = async () => {
    try {
      await npsService.postNpsRate(rate, hash, comment);
      rated(rate);
    } catch (e) {
      setError(true);
    }
  };

  const rateItems = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
      .map((number) => {
        return <RateItem value={number}
                         onClick={() => setRate(number)}
                         key={number}
                         active={number === rate}/>;
      });

  let commentBlock = null;
  if (rate > 0 && rate < 7) {
    commentBlock = (
        <CommentBlock item xs={6}>
          <TextField onChange={e => setComment(e.target.value)} label={'Комментарий'}
                     focused fullWidth variant={'outlined'} multiline
                     placeholder={'Что бы вы хотели изменить?'}
          />
        </CommentBlock>
    );
  }

  return (
      <StyledPaper>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography align={'center'} variant={'body1'}>
              {question}
            </Typography>
          </Grid>
          <Grid item container xs={12} direction={'row'}>
            <Grid item xs={3}>
            </Grid>
            <Grid item container xs={6}>
              {rateItems}
              <Border>
                <BorderItem theme={theme} size={6} variant={'error'} mr={'5px'}
                            pr={'15px'}/>
                <BorderItem theme={theme} size={2} variant={'primary'}
                            mr={'5px'} pr={'5px'}/>
                <BorderItem theme={theme} size={2} variant={'success'} mr={'5px'}/>
              </Border>
            </Grid>
            <Grid item xs={3}>
            </Grid>
          </Grid>
          {commentBlock}
          <ButtonWrapper item xs={12}>
            <Button disabled={rate < 1}
                    variant={'contained'} color={'primary'}
                    onClick={sendRate}>Оценить</Button>
          </ButtonWrapper>
        </Grid>


        <StyledSnackbar visible={showError} severity={'warning'}
                        onClose={() => setError(false)}/>
      </StyledPaper>
  );
};

export default RateDesktop;
